import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SedsAlertBasicComponent } from './seds-alert-basic.component';
import { SedsAlertCoreModule } from '../../seds-alert/seds-alert-core/seds-alert-core.module';

@NgModule({
  declarations: [SedsAlertBasicComponent],
  imports: [CommonModule, SedsAlertCoreModule],
  exports: [SedsAlertBasicComponent],
})
export class SedsAlertBasicModule {}
